// src/App.tsx

import { useEffect, useState } from 'react';
import SplashScreen from './SplashScreen';
import geoassistantLogo from './assets/geoassistant_logo_dark.svg';
import { AppShell } from './components/shell/AppShell';
import { loginUrl, logoutUrl, userMeUrl } from './api/urls';

type AuthUser = {
  name: string;
  email: string;
  picture: string;
  sub: string;
};

const DEV_MODE = import.meta.env.DEV;
const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function App() {
  const [user, setUser]     = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (DEV_MODE) {
      setUser({ name: 'Test User', email: 'test@test.com', picture: '', sub: 'test' });
      setLoading(false);
      return;
    }

    Promise.all([
      fetch(userMeUrl, { method: 'GET', credentials: 'include' })
        .then((res) => {
          if (!res.ok) throw new Error('Not authenticated');
          return res.json();
        })
        .then((data) => setUser(data))
        .catch(() => {
          window.location.href = loginUrl;
          return new Promise(() => {});
        }),
      wait(1000),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <SplashScreen isVisible={true} logo={geoassistantLogo} />;
  if (!user) return null;

  return (
    <AppShell
      userName={user.name}
      userEmail={user.email}
      onLogout={() => (window.location.href = logoutUrl)}
    />
  );
}

export default App;